import { TypedDocumentNode, gql } from '@apollo/client';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { sortBy } from '@sorare/core/src/lib/arrays';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from 'components/so5/Rules/types';

import { getSeasonsRule_so5Rules } from './__generated__/getSeasonsRule.graphql';

export const getSeasonsRule = withFragments(
  (rules: getSeasonsRule_so5Rules, error: string): RuleHelperFnReturnType => {
    const rule = rules.seasons;
    if (!rule?.length) {
      return null;
    }

    return {
      id: 'seasons',
      label: (
        <FormattedMessage id="Rules.seasons.label" defaultMessage="Seasons" />
      ),
      description: (
        <Vertical as="span" gap={0}>
          {sortBy(season => season.startYear, rule).map(season => (
            <span key={season.startYear}>
              <FormattedMessage
                id="Rules.seasons.yearSeason"
                defaultMessage="{season} Season"
                values={{
                  season: `${season.startYear.toString().slice(2)}/${(season.startYear + 1).toString().slice(2)}`,
                }}
              />
            </span>
          ))}
        </Vertical>
      ),
      icon: <FontAwesomeIcon icon={faCalendar} width="16" height="16" />,
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getSeasonsRule_so5Rules on So5Rules {
        id
        seasons {
          startYear
          name
        }
      }
    ` as TypedDocumentNode<getSeasonsRule_so5Rules>,
  }
);
